import { Controller } from "@hotwired/stimulus"
import { syncReceivablesOverview } from "../../utils/overview-sync.util"
import TableFrameNavigator from "../../utils/table_frame_navigator"
import TableQueryState from "../../utils/table_query_state"

// Connects to data-controller="documents--quick-filters"
export default class extends Controller {
  static outlets = ["document-filter"]

  connect() {
    this.tableNavigator = new TableFrameNavigator({
      frameId: "documents",
      tableKey: this.element.closest(".documents-table-controller")?.dataset.tableNavigationTableKeyValue || null
    })
    this.#initializeQuickFilters()
  }

  disconnect() {
    this.tableNavigator?.disconnect()
  }

  applyQuickFilter(event) {
    const currentQueryParams = new URLSearchParams(window.location.search)
    let newParams = new URLSearchParams()
    const documentFilterController = this.hasDocumentFilterOutlet ? this.documentFilterOutlet : null
    if (event.target.value !== "all" && !currentQueryParams.has("quickFilter")) {
      this.element.dataset.queryParams = currentQueryParams.toString()
      documentFilterController?.removeValuesFromFilters()
    }
    if (event.target.value !== "all") {
      newParams.set("quickFilter", event.target.value)
    }

    const currentYear = new Date().getUTCFullYear()
    const lastYear = currentYear - 1

    switch (event.target.value) {
      case "all":
        newParams = new URLSearchParams(this.element.dataset.queryParams || "")
        break
      case "issued_this_year":
        newParams.set("issuedFrom", `${currentYear}-01-01`)
        newParams.set("issuedTo", `${currentYear}-12-31`)
        break
      case "issued_last_year":
        newParams.set("issuedFrom", `${lastYear}-01-01`)
        newParams.set("issuedTo", `${lastYear}-12-31`)
        break
      case "delivered_this_year":
        newParams.set("deliveryDateFrom", `${currentYear}-01-01`)
        newParams.set("deliveryDateTo", `${currentYear}-12-31`)
        break
      case "delivered_last_year":
        newParams.set("deliveryDateFrom", `${lastYear}-01-01`)
        newParams.set("deliveryDateTo", `${lastYear}-12-31`)
        break
      case "paid_this_year":
        newParams.set("paidFrom", `${currentYear}-01-01`)
        newParams.set("paidTo", `${currentYear}-12-31`)
        break
      case "paid_last_year":
        newParams.set("paidFrom", `${lastYear}-01-01`)
        newParams.set("paidTo", `${lastYear}-12-31`)
        break
      case "paid_all":
        newParams.set("paymentStatus[]", "paid")
        newParams.append("paymentStatus[]", "overpaid")
        break
      case "unpaid_all":
        newParams.set("paymentStatus[]", "unpaid")
        newParams.append("paymentStatus[]", "partially_paid")
        break
      case "overdue":
        newParams.set("overdue", "1")
        break
      case "active":
        newParams.set("status[]", "active")
        break
      case "suspended":
        newParams.set("status[]", "suspended")
        break
      case "finished":
        newParams.set("status[]", "finished")
        break
      default:
        break
    }
    this.#constructUrlAndSendRequest(newParams)
  }

  #constructUrlAndSendRequest(params) {
    this.#preserveForecastParams(params)
    const queryState = new TableQueryState(params)
    this.tableNavigator.navigate(queryState, {
      history: "push",
      reason: "filter",
      preserveScroll: { x: true, y: false }
    })
    syncReceivablesOverview(this.application, queryState.toSearchParams())
  }

  #preserveForecastParams(params) {
    const current = new URLSearchParams(window.location.search)
    if (current.has("forecast")) {
      params.set("forecast", current.get("forecast"))
    }
  }

  #initializeQuickFilters() {
    const currentQueryParams = new URLSearchParams(window.location.search)
    const allRadio = document.getElementById("quick_filter_all")
    if (currentQueryParams.has("quickFilter")) {
      const quickFilterId = `quick_filter_${currentQueryParams.get("quickFilter")}`
      const radio = document.getElementById(quickFilterId)
      if (radio) radio.checked = true
      else if (allRadio) allRadio.checked = true
    } else if (allRadio) {
      allRadio.checked = true
    }
  }
}
